export default __webpack_public_path__ + "static/media/my-location.29a3c4c6.svg";